import React, { ReactElement } from 'react';
import { Page } from 'components';

import { AuthLoginBox } from 'features/auth/components';
import { useSchool } from 'features/school';

const LoginView = (): ReactElement => {
  const { schoolIsPublic, schoolAlias } = useSchool();
  let description = '';

  if (schoolAlias === 'xp') {
    description = 'Preencha os campos abaixo para acessar a UXP';
  }

  return (
    <Page title="Login">
      <AuthLoginBox showRegisterLink={schoolIsPublic} description={description} />
    </Page>
  );
};

export default LoginView;
